// extracted by mini-css-extract-plugin
export default {"wrapper":"AllCollections_wrapper__dGMMv","item":"AllCollections_item__KlMCv"};